import { merge } from 'lodash';
import React from 'react';
import { identifyComponent } from '../../../util';
import { TableBody } from '../TableBody';
import { TableHead } from '../TableHead';
import { TableSortContextProvider } from '../TableSortContext';
import { TableBase } from './Base';
import { TableProps } from './types';

export function Table<R>({
  className,
  testId = 'table',
  columns,
  rows,
  rowKeyAccessor,
  dense,
  borders,
  fixed,
  disableGutters,
  headComponent: Head = TableHead,
  headProps = {},

  bodyComponent: Body = TableBody,
  bodyProps = {},

  activeSortColumnKey,
  activeSortDirection,
  onSortChange,
  setActiveSortColumn,
  setActiveSortDirection,
  ...restOfProps
}: TableProps<React.ElementType, React.ElementType, R>) {
  const hProps = merge({ rowProps: { cellProps: { borders } } }, headProps);
  const bProps = merge({ rowProps: { cellProps: { borders } } }, bodyProps);

  return (
    <TableSortContextProvider
      activeSortColumnKey={activeSortColumnKey}
      activeSortDirection={activeSortDirection}
      onSortChange={onSortChange}
      setActiveSortColumn={setActiveSortColumn}
      setActiveSortDirection={setActiveSortDirection}
    >
      <TableBase
        data-component="Table"
        className={className}
        testId={testId}
        dense={dense}
        borders={borders}
        fixed={fixed}
        disableGutters={disableGutters}
        {...identifyComponent('table')}
        {...restOfProps}
      >
        <colgroup>
          {columns.map(({ key, width, minWidth }) => (
            <col key={key} style={{ width, minWidth }} />
          ))}
        </colgroup>
        <Head columns={columns} {...hProps} />
        <Body columns={columns} rows={rows} rowKeyAccessor={rowKeyAccessor} {...bProps} />
      </TableBase>
    </TableSortContextProvider>
  );
}
